import { useContext } from 'react';
import { VacancyContext } from 'context/VacancyContext';

const useVacancyContext = () => {
  const ctx = useContext(VacancyContext);
  return { ...ctx };
};

export default useVacancyContext;
